import { createContext, useContext, useState } from "react";

const en = {
  nav_services: "Services",
  nav_quote: "Instant Quote",
  nav_book: "Book a Visit",
  nav_areas: "Areas",
  nav_cta: "Instant Quote",

  hero_eyebrow: "Centralia · Chehalis · Olympia WA",
  hero_l1: "THE RIGHT FLOOR.",
  hero_l2: "MEASURED RIGHT.",
  hero_l3: "INSTALLED RIGHT.",
  hero_sub:
    "Master carpet, laminate and luxury vinyl plank installation for homes and businesses across Lewis and Thurston County. Get an instant estimate from your own measurements, then book a free on-site visit — we come to you, measure precisely, and confirm your final price.",
  hero_cta1: "Get My Instant Quote",
  hero_cta2: "Book a Measurement Visit",
  chip1: "Free In-Home Measurements",
  chip2: "Licensed & Insured",
  chip3: "Carpet · Laminate · LVP",
  chip4: "Commercial & Residential",
  brand_sub: "Commercial & Residential",
  prop_type: "Property Type",
  prop_res: "Residential",
  prop_com: "Commercial",
  com_note:
    "Offices, retail and rentals: we confirm firm commercial pricing on site after measuring.",
  com_hourly_rate: "Commercial repair rate: $75 – $150 / hour",
  com_hourly_note: "Total hours confirmed on site — book a visit for a firm quote.",
  addon_subfloor: "Subfloor prep / leveling",
  addon_subfloor_price: "+$9–$22.50/sq yd",
  addon_remove_price_com: "+$4.50–$11.25/sq yd",
  stairs_hint_com: "+$20–$40 per step",
  dash_gallery: "Gallery Photos",
  dash_gallery_sub: "Photos you upload appear on the website gallery.",
  dash_caption_ph: "Caption (optional)",
  dash_upload: "Upload Photo",
  dash_uploading: "Uploading...",
  dash_remove_photo: "Remove",
  dash_photo_added: "Photo added to the gallery",
  dash_photo_removed: "Photo removed",
  dash_upload_fail: "Upload failed. Try a smaller image (max 10MB).",
  dash_move_left: "Move earlier",
  dash_move_right: "Move later",
  badge_free: "Free",
  badge_free_sub: "In-Home Estimate",

  mq1: "Centralia WA",
  mq2: "Chehalis WA",
  mq3: "Olympia WA",
  mq4: "Free In-Home Measurements",
  mq5: "360-861-7655",
  mq6: "Carpet & LBP Specialists",
  mq7: "Licensed & Insured",

  services_eyebrow: "The Craft — Seven Specialties",
  services_h: "Every floor, installed like it was ours.",
  services_sub:
    "Straight pricing per square yard. Pick your surface, run your numbers, and we confirm the final quote in person.",
  services_swipe: "Swipe to see all 7 services",
  wa_label: "Chat with us on WhatsApp",
  wa_cta: "WhatsApp us",
  wa_message: "Hi PERETE Flooring! I'd like a quote for new flooring. ",
  wa_alerts_title: "WhatsApp alerts",
  wa_status_on: "Active",
  wa_status_sandbox: "Sandbox",
  wa_status_off: "Not configured",
  wa_alerts_on_sub: "Every new quote and appointment is also sent to",
  wa_alerts_off_sub:
    "Add TWILIO_ACCOUNT_SID and TWILIO_AUTH_TOKEN to the backend settings to receive every new quote and appointment on WhatsApp.",
  wa_sandbox_hint:
    "Sandbox mode: send any message to +1 415 523 8886 from your WhatsApp once a day to keep the 24h window open.",
  wa_send_test: "Send test message",
  wa_sending: "Sending…",
  wa_test_ok: "Test message sent — check your WhatsApp",
  wa_test_fail: "Could not send the test message.",
  pw_or: "or with your password",
  pw_email_ph: "Email",
  pw_password_ph: "Password",
  pw_login_btn: "Sign in with password",
  pw_signing_in: "Signing in…",
  pw_login_fail: "Incorrect email or password",
  pw_forgot_link: "Forgot password / create one",
  pw_forgot_sub: "Enter the owner email and we'll send a link to set a new password (valid for 60 minutes).",
  pw_forgot_btn: "Send reset link",
  pw_forgot_sent: "If that email belongs to the owner, a reset link is on its way. Check your inbox.",
  pw_forgot_fail: "Could not send the reset email. Try again in a moment.",
  pw_sending: "Sending…",
  pw_back_login: "Back to sign in",
  sec_title: "Password sign-in",
  sec_status_set: "Enabled",
  sec_status_unset: "Not set",
  sec_sub_set: "You can sign in with Google or with your email and password.",
  sec_sub_unset: "Create a password so you can sign in without Google (for example from a new device).",
  sec_create_btn: "Create password",
  sec_change_btn: "Change password",
  sec_current_ph: "Current password",
  sec_new_ph: "New password (min. 8 characters)",
  sec_confirm_ph: "Confirm new password",
  sec_save_btn: "Save password",
  sec_cancel: "Cancel",
  sec_saved: "Password saved",
  sec_fail: "Could not save the password.",
  sec_min_len: "Password must be at least 8 characters.",
  sec_mismatch: "Passwords do not match.",
  reset_title: "Set a new password",
  reset_sub: "Choose a new password for the owner account.",
  reset_btn: "Save new password",
  reset_ok: "Password updated",
  reset_fail: "This reset link is invalid or has expired.",
  reset_done: "Your password was updated. You can sign in now.",
  reset_no_token: "This link is missing its token. Request a new reset email from the sign-in page.",
  reset_go_login: "Go to sign in",

  quote_eyebrow: "Instant Estimate",
  quote_h: "Know your number before we knock.",
  quote_sub:
    "Enter your room size — or the square yards if you already know them — pick a surface, and get a real price range in seconds. No email required to calculate.",
  note1: "9 sq ft = 1 sq yd — we convert for you",
  note2: "Honest Washington labor rates per square yard",
  note3: "Carpet pad, stairs & subfloor prep quoted separately",
  note4: "Final price confirmed with free in-home measurement",
  mode_room: "Measure a Room",
  mode_yards: "I Know My Sq Yards",
  length_l: "Length (ft)",
  width_l: "Width (ft)",
  yards_l: "Total Square Yards",
  flooring_l: "Flooring Type",
  addon_remove: "Remove & haul away old carpet",
  addon_remove_price: "+$4.50–$9/sq yd",
  addon_cuts: "Lots of cuts, closets or small rooms",
  addon_cuts_price: "+$3–$7/sq yd",
  addon_seam: "Include seam repair",
  addon_seam_price: "combined rate $11.25–$18/sq yd",
  stairs_l: "Carpet stairs (number of steps)",
  stairs_hint: "+$15–$30 per step",
  calc_btn: "Calculate My Estimate",
  est_yards: "Estimated Yardage",
  est_range: "Estimated Range",
  your_name: "Your name",
  your_phone: "Phone number",
  send_quote: "Send This Quote to PERETE",
  sending: "Sending...",
  book_visit: "Book Free Measurement Visit",
  err_measure: "Enter valid measurements first.",
  err_contact: "Add your name and phone so we can reach you.",
  quote_sent: "Quote sent — we'll call you back shortly.",
  quote_fail: "Could not send the quote. Please call 360-861-7655.",

  appt_eyebrow: "Free In-Home Visit",
  appt_h: "Book your measurement visit.",
  appt_sub:
    "Pick a day and time that works for you. We come to your home, take exact measurements, and hand you a firm written estimate on the spot — no obligation.",
  first_name: "First Name *",
  last_name: "Last Name *",
  phone_l: "Phone",
  email_l: "Email",
  email_hint: "optional, for your appointment reminder",
  dash_reminder_sent: "Reminder sent",
  dash_reminder_pending: "Reminder: day before",
  city_l: "City",
  address_l: "Home Address *",
  date_l: "Preferred Date *",
  time_l: "Preferred Time",
  service_l: "Service Needed",
  notes_l: "Notes",
  ph_address: "Street address where we'll measure",
  ph_notes: "Rooms, sizes, anything we should know...",
  city_nearby: "Nearby area",
  slot_morning: "Morning (8am – 12pm)",
  slot_afternoon: "Afternoon (12pm – 4pm)",
  slot_evening: "Late Afternoon (4pm – 7pm)",
  submit_appt: "Request My Appointment",
  confirm_note: "We confirm every visit by phone",
  err_name: "Please add your first and last name.",
  err_addr: "Please add your home address.",
  err_date: "Please pick a preferred date.",
  appt_sent: "Appointment request sent!",
  appt_fail: "Could not send the request. Please call 360-861-7655.",
  modal_title: "You're on the books",
  modal_body:
    "We'll visit {address} ({city}) on {date} — {slot}. We'll call to confirm shortly.",
  modal_done: "Done",
  modal_close: "Close confirmation",

  footer_eyebrow: "Service Areas",
  footer_h: "Centralia · Chehalis · Olympia",
  footer_sub:
    "Locally owned and operated. If you're in Lewis or Thurston County, we'll come to you — measurements and estimates are always free.",
  footer_call: "Call 360-861-7655",
  owner_login: "Owner Sign In",
  back_top: "Back to top ↑",

  gal_eyebrow: "Recent Work",
  gal_h: "Before & after — the proof is under your feet.",
  gal_sub:
    "Real PERETE jobs, real transformations — drag the handle on each photo to compare old carpet to brand-new plank floors.",
  gal_before: "Before",
  gal_after: "After",
  gal_drag: "Drag to compare",
  gal_proj1: "Bedroom — stained carpet to new plank floor",
  gal_proj2: "Living room — shag carpet to luxury vinyl plank",
  gal_proj3: "Tile repair — damaged marble-look tile replaced seamlessly",
  gal_proj4: "Bedroom — bare plywood subfloor to plush new carpet",
  gal_more: "More recent installs",
  gal_p1: "New carpet — bedroom",
  gal_p2: "New carpet — walk-in closet",
  gal_p3: "New carpet — hallway & bedroom",
  gal_p4: "Grey LVP — living room with fireplace",
  gal_p5: "Grey LVP — kitchen & dining",
  vid_eyebrow: "Video walkthrough",
  vid_h: "Same house. Same week. Watch the switch.",
  vid_sub:
    "Two quick clips from a real job: the old carpet coming out, and the new carpet laid on the stairs, hallway and bedrooms.",
  vid_step1: "Old carpet and pad pulled up, subfloor cleaned",
  vid_step2: "New pad, tack strips and carpet stretched tight",
  vid_step3: "Stairs wrapped and every edge trimmed clean",
  vid_hint: "Tap a video to play or pause",
  gal_more_videos: "More job videos",
  share_label: "Share",
  share_more: "More",
  share_copy: "Copy link",
  share_copied: "Link copied — paste it anywhere (Instagram bio, DM, story)",
  share_copy_fail: "Could not copy the link",
  share_title: "PERETE Flooring — before & after",
  share_text: "Check out this flooring before & after by PERETE Flooring and Carpet Installation.",
  dash_videos: "Job Videos",
  dash_videos_sub:
    "Upload short clips from your phone (MP4/MOV, up to 200MB). They are compressed automatically and appear in the site gallery when ready.",
  dash_video_upload: "Upload video",
  dash_video_pick: "Choose a video file first.",
  dash_video_too_big: "Video too large (max 200MB).",
  dash_video_queued: "Video uploaded — compressing, it will appear shortly",
  dash_video_fail: "Could not upload the video.",
  dash_video_removed: "Video removed",
  dash_video_processing: "Processing",
  dash_video_failed: "Failed",

  rev_eyebrow: "Happy Homeowners",
  rev_h: "Neighbors who love their new floors.",
  rev_sub: "What your neighbors say about working with PERETE.",
  rev1_text:
    "They showed up on time, measured everything, and the new carpet feels incredible. Fair price, zero surprises.",
  rev1_name: "Maria G.",
  rev1_meta: "Centralia — Carpet Installation",
  rev2_text:
    "Waterproof LVP in the kitchen and it looks like real wood. Clean, fast, professional work from start to finish.",
  rev2_name: "James T.",
  rev2_meta: "Chehalis — Vinyl Plank",
  rev3_text:
    "Ten years of carpet wrinkles gone in one afternoon. Should have called PERETE years ago.",
  rev3_name: "Sandra L.",
  rev3_meta: "Olympia — Carpet Restretching",

  dash_title: "Owner Dashboard",
  dash_site: "Site",
  dash_signout: "Sign out",
  dash_quotes: "Quote Requests",
  dash_upcoming: "Upcoming Visits",
  dash_completed: "Completed",
  dash_appointments: "Appointments",
  dash_empty_appts: "No upcoming appointments.",
  dash_archived: "Completed & Archived",
  dash_quotes_h: "Quote Requests",
  dash_empty_quotes: "No quote requests yet.",
  dash_received: "Received",
  dash_done: "Mark Done",
  dash_reopen: "Reopen",
  dash_toast_done: "Marked as done — archived",
  dash_toast_reopen: "Moved back to upcoming",
  dash_toast_fail: "Could not update the appointment.",
  dash_signed_out: "Signed out",
  dash_checking: "Checking access…",
  dash_access: "Owner Access",
  dash_forbidden:
    "This Google account isn't authorized for the owner dashboard. Sign in with the business account.",
  dash_login_sub:
    "Sign in with your Google account to view quote requests and measurement appointments.",
  dash_signin: "Sign in with Google",
  dash_back: "Back to site",
  dash_expenses_link: "Expenses",
  exp_title: "Expense Log",
  exp_sub: "Business expenses — type an amount, pick a category and hit Enter.",
  exp_month_total: "Spent this month",
  exp_month_count: "entries this month",
  exp_top_category: "Top category this month",
  exp_filtered_total: "Total shown",
  exp_amount_ph: "0.00",
  exp_note_ph: "Note (optional)",
  exp_add: "Add",
  exp_adding: "Saving…",
  exp_all: "All",
  exp_empty: "No expenses yet. Add your first one above.",
  exp_empty_filter: "No expenses in this category.",
  exp_added: "Expense saved",
  exp_removed: "Expense deleted",
  exp_fail: "Could not save the expense.",
  exp_invalid_amount: "Enter an amount greater than zero.",
  exp_delete: "Delete expense",
  exp_dashboard: "Dashboard",
  exp_entries: "entries",
  cat_materials: "Materials",
  cat_tools: "Tools",
  cat_gas: "Gas",
  cat_labor: "Labor",
  cat_advertising: "Advertising",
  cat_other: "Other",
};

const es = {
  nav_services: "Servicios",
  nav_quote: "Cotización",
  nav_book: "Agendar Visita",
  nav_areas: "Zonas",
  nav_cta: "Cotización",

  hero_eyebrow: "Centralia · Chehalis · Olympia WA",
  hero_l1: "EL PISO PERFECTO.",
  hero_l2: "MEDIDO BIEN.",
  hero_l3: "INSTALADO BIEN.",
  hero_sub:
    "Instalación experta de alfombra, laminado y vinyl de lujo para hogares y negocios en los condados Lewis y Thurston. Obtén un estimado al instante con tus propias medidas y agenda una visita gratis — nosotros medimos con precisión y confirmamos tu precio final.",
  hero_cta1: "Obtener Mi Cotización",
  hero_cta2: "Agendar Visita de Medición",
  chip1: "Mediciones en Casa Gratis",
  chip2: "Licenciados y Asegurados",
  chip3: "Alfombra · Laminado · LVP",
  chip4: "Comercial y Residencial",
  brand_sub: "Comercial y Residencial",
  prop_type: "Tipo de Propiedad",
  prop_res: "Residencial",
  prop_com: "Comercial",
  com_note:
    "Oficinas, tiendas y rentas: confirmamos el precio comercial firme en el lugar después de medir.",
  com_hourly_rate: "Tarifa de reparación comercial: $75 – $150 / hora",
  com_hourly_note: "Las horas finales se confirman en el lugar — agenda una visita para cotización firme.",
  addon_subfloor: "Preparación / nivelación del piso",
  addon_subfloor_price: "+$9–$22.50/yd²",
  addon_remove_price_com: "+$4.50–$11.25/yd²",
  stairs_hint_com: "+$20–$40 por escalón",
  dash_gallery: "Fotos de la Galería",
  dash_gallery_sub: "Las fotos que subas aparecen en la galería del sitio web.",
  dash_caption_ph: "Descripción (opcional)",
  dash_upload: "Subir Foto",
  dash_uploading: "Subiendo...",
  dash_remove_photo: "Quitar",
  dash_photo_added: "Foto agregada a la galería",
  dash_photo_removed: "Foto eliminada",
  dash_upload_fail: "Falló la subida. Prueba con una imagen más chica (máx 10MB).",
  dash_move_left: "Mover antes",
  dash_move_right: "Mover después",
  badge_free: "Gratis",
  badge_free_sub: "Estimado en Casa",

  mq1: "Centralia WA",
  mq2: "Chehalis WA",
  mq3: "Olympia WA",
  mq4: "Mediciones en Casa Gratis",
  mq5: "360-861-7655",
  mq6: "Especialistas en Alfombra y LVP",
  mq7: "Licenciados y Asegurados",

  services_eyebrow: "El Oficio — Siete Especialidades",
  services_h: "Cada piso, instalado como si fuera el nuestro.",
  services_sub:
    "Precios claros por yarda cuadrada. Elige tu superficie, haz tus números y confirmamos la cotización final en persona.",
  services_swipe: "Desliza para ver los 7 servicios",
  wa_label: "Escríbenos por WhatsApp",
  wa_cta: "Escríbenos",
  wa_message: "¡Hola PERETE Flooring! Me gustaría una cotización para pisos nuevos. ",
  wa_alerts_title: "Avisos por WhatsApp",
  wa_status_on: "Activo",
  wa_status_sandbox: "Sandbox",
  wa_status_off: "Sin configurar",
  wa_alerts_on_sub: "Cada nueva cotización y cita también se envía al",
  wa_alerts_off_sub:
    "Agrega TWILIO_ACCOUNT_SID y TWILIO_AUTH_TOKEN en la configuración del backend para recibir cada cotización y cita en tu WhatsApp.",
  wa_sandbox_hint:
    "Modo sandbox: envía cualquier mensaje al +1 415 523 8886 desde tu WhatsApp una vez al día para mantener abierta la ventana de 24 h.",
  wa_send_test: "Enviar mensaje de prueba",
  wa_sending: "Enviando…",
  wa_test_ok: "Mensaje de prueba enviado — revisa tu WhatsApp",
  wa_test_fail: "No se pudo enviar el mensaje de prueba.",
  pw_or: "o con tu contraseña",
  pw_email_ph: "Correo electrónico",
  pw_password_ph: "Contraseña",
  pw_login_btn: "Entrar con contraseña",
  pw_signing_in: "Entrando…",
  pw_login_fail: "Correo o contraseña incorrectos",
  pw_forgot_link: "Olvidé mi contraseña / crear una",
  pw_forgot_sub: "Escribe el correo del dueño y te enviaremos un enlace para crear una nueva contraseña (válido 60 minutos).",
  pw_forgot_btn: "Enviar enlace",
  pw_forgot_sent: "Si ese correo es el del dueño, el enlace ya va en camino. Revisa tu bandeja de entrada.",
  pw_forgot_fail: "No se pudo enviar el correo. Intenta de nuevo en un momento.",
  pw_sending: "Enviando…",
  pw_back_login: "Volver a iniciar sesión",
  sec_title: "Acceso con contraseña",
  sec_status_set: "Activo",
  sec_status_unset: "Sin crear",
  sec_sub_set: "Puedes entrar con Google o con tu correo y contraseña.",
  sec_sub_unset: "Crea una contraseña para poder entrar sin Google (por ejemplo desde otro dispositivo).",
  sec_create_btn: "Crear contraseña",
  sec_change_btn: "Cambiar contraseña",
  sec_current_ph: "Contraseña actual",
  sec_new_ph: "Nueva contraseña (mín. 8 caracteres)",
  sec_confirm_ph: "Confirmar nueva contraseña",
  sec_save_btn: "Guardar contraseña",
  sec_cancel: "Cancelar",
  sec_saved: "Contraseña guardada",
  sec_fail: "No se pudo guardar la contraseña.",
  sec_min_len: "La contraseña debe tener al menos 8 caracteres.",
  sec_mismatch: "Las contraseñas no coinciden.",
  reset_title: "Crear nueva contraseña",
  reset_sub: "Elige una nueva contraseña para la cuenta del dueño.",
  reset_btn: "Guardar nueva contraseña",
  reset_ok: "Contraseña actualizada",
  reset_fail: "Este enlace es inválido o ya expiró.",
  reset_done: "Tu contraseña fue actualizada. Ya puedes iniciar sesión.",
  reset_no_token: "A este enlace le falta el código. Pide un nuevo correo desde la pantalla de inicio de sesión.",
  reset_go_login: "Ir a iniciar sesión",

  quote_eyebrow: "Estimado al Instante",
  quote_h: "Conoce tu precio antes de que toquemos a tu puerta.",
  quote_sub:
    "Ingresa el tamaño de tu cuarto — o las yardas cuadradas si ya las sabes — elige el tipo de piso y obtén un rango de precio real en segundos. No necesitas dar tu correo para calcular.",
  note1: "9 pies² = 1 yarda² — lo convertimos por ti",
  note2: "Tarifas honestas de mano de obra en Washington por yarda²",
  note3: "Pad de alfombra, escaleras y preparación del piso se cotizan aparte",
  note4: "Precio final confirmado con medición gratis en tu casa",
  mode_room: "Medir un Cuarto",
  mode_yards: "Ya Sé Mis Yardas²",
  length_l: "Largo (pies)",
  width_l: "Ancho (pies)",
  yards_l: "Yardas Cuadradas Totales",
  flooring_l: "Tipo de Piso",
  addon_remove: "Quitar y llevar la alfombra vieja",
  addon_remove_price: "+$4.50–$9/yd²",
  addon_cuts: "Muchos cortes, closets o cuartos chicos",
  addon_cuts_price: "+$3–$7/yd²",
  addon_seam: "Incluir reparación de costuras",
  addon_seam_price: "tarifa combinada $11.25–$18/yd²",
  stairs_l: "Escaleras de alfombra (número de escalones)",
  stairs_hint: "+$15–$30 por escalón",
  calc_btn: "Calcular Mi Estimado",
  est_yards: "Yardas Estimadas",
  est_range: "Rango Estimado",
  your_name: "Tu nombre",
  your_phone: "Número de teléfono",
  send_quote: "Enviar Cotización a PERETE",
  sending: "Enviando...",
  book_visit: "Agendar Medición Gratis en Casa",
  err_measure: "Ingresa medidas válidas primero.",
  err_contact: "Agrega tu nombre y teléfono para contactarte.",
  quote_sent: "Cotización enviada — te llamaremos pronto.",
  quote_fail: "No se pudo enviar. Llama al 360-861-7655.",

  appt_eyebrow: "Visita Gratis a Tu Casa",
  appt_h: "Agenda tu visita de medición.",
  appt_sub:
    "Elige el día y la hora que te convengan. Vamos a tu casa, tomamos medidas exactas y te damos un estimado firme por escrito en el momento — sin compromiso.",
  first_name: "Nombre *",
  last_name: "Apellido *",
  phone_l: "Teléfono",
  email_l: "Correo electrónico",
  email_hint: "opcional, para tu recordatorio de cita",
  dash_reminder_sent: "Recordatorio enviado",
  dash_reminder_pending: "Recordatorio: un día antes",
  city_l: "Ciudad",
  address_l: "Domicilio *",
  date_l: "Fecha Preferida *",
  time_l: "Hora Preferida",
  service_l: "Servicio Necesitado",
  notes_l: "Notas",
  ph_address: "Dirección donde mediremos",
  ph_notes: "Cuartos, medidas, algo que debamos saber...",
  city_nearby: "Zona cercana",
  slot_morning: "Mañana (8am – 12pm)",
  slot_afternoon: "Tarde (12pm – 4pm)",
  slot_evening: "Tarde Noche (4pm – 7pm)",
  submit_appt: "Solicitar Mi Cita",
  confirm_note: "Confirmamos cada visita por teléfono",
  err_name: "Agrega tu nombre y apellido.",
  err_addr: "Agrega tu domicilio.",
  err_date: "Elige una fecha.",
  appt_sent: "¡Cita enviada!",
  appt_fail: "No se pudo enviar. Llama al 360-861-7655.",
  modal_title: "¡Cita agendada",
  modal_body:
    "Te visitaremos en {address} ({city}) el {date} — {slot}. Te llamaremos para confirmar.",
  modal_done: "Listo",
  modal_close: "Cerrar confirmación",

  footer_eyebrow: "Zonas de Servicio",
  footer_h: "Centralia · Chehalis · Olympia",
  footer_sub:
    "Negocio local de la zona. Si estás en el condado Lewis o Thurston, vamos a ti — las mediciones y los estimados siempre son gratis.",
  footer_call: "Llama al 360-861-7655",
  owner_login: "Entrar (Dueño)",
  back_top: "Volver arriba ↑",

  gal_eyebrow: "Trabajos Recientes",
  gal_h: "Antes y después — la prueba está bajo tus pies.",
  gal_sub:
    "Trabajos reales de PERETE, transformaciones reales — arrastra el control en cada foto para comparar la alfombra vieja con el piso nuevo.",
  gal_before: "Antes",
  gal_after: "Después",
  gal_drag: "Arrastra para comparar",
  gal_proj1: "Recámara — de alfombra manchada a piso plank nuevo",
  gal_proj2: "Sala — de alfombra vieja a vinyl plank de lujo",
  gal_proj3: "Reparación de loseta — pieza dañada tipo mármol reemplazada sin notarse",
  gal_proj4: "Recámara — de subpiso de madera a alfombra nueva",
  gal_more: "Más instalaciones recientes",
  gal_p1: "Alfombra nueva — recámara",
  gal_p2: "Alfombra nueva — closet vestidor",
  gal_p3: "Alfombra nueva — pasillo y recámara",
  gal_p4: "LVP gris — sala con chimenea",
  gal_p5: "LVP gris — cocina y comedor",
  vid_eyebrow: "Recorrido en video",
  vid_h: "Misma casa. Misma semana. Mira el cambio.",
  vid_sub:
    "Dos clips cortos de un trabajo real: la alfombra vieja saliendo, y la alfombra nueva instalada en escaleras, pasillo y recámaras.",
  vid_step1: "Se retira la alfombra vieja y el acolchado, se limpia el subpiso",
  vid_step2: "Acolchado nuevo, tiras de sujeción y alfombra bien estirada",
  vid_step3: "Escaleras forradas y cada orilla recortada limpia",
  vid_hint: "Toca un video para reproducir o pausar",
  gal_more_videos: "Más videos de trabajos",
  share_label: "Compartir",
  share_more: "Más",
  share_copy: "Copiar enlace",
  share_copied: "Enlace copiado — pégalo donde quieras (bio de Instagram, mensaje, historia)",
  share_copy_fail: "No se pudo copiar el enlace",
  share_title: "PERETE Flooring — antes y después",
  share_text: "Mira este antes y después de pisos por PERETE Flooring and Carpet Installation.",
  dash_videos: "Videos de Trabajos",
  dash_videos_sub:
    "Sube clips cortos desde tu celular (MP4/MOV, hasta 200MB). Se comprimen automáticamente y aparecen en la galería del sitio cuando estén listos.",
  dash_video_upload: "Subir video",
  dash_video_pick: "Primero elige un archivo de video.",
  dash_video_too_big: "Video demasiado grande (máx. 200MB).",
  dash_video_queued: "Video subido — comprimiendo, aparecerá en un momento",
  dash_video_fail: "No se pudo subir el video.",
  dash_video_removed: "Video eliminado",
  dash_video_processing: "Procesando",
  dash_video_failed: "Falló",

  rev_eyebrow: "Clientes Contentos",
  rev_h: "Vecinos que aman sus pisos nuevos.",
  rev_sub: "Lo que dicen tus vecinos de trabajar con PERETE.",
  rev1_text:
    "Llegaron a tiempo, midieron todo y la alfombra nueva se siente increíble. Precio justo, sin sorpresas.",
  rev1_name: "Maria G.",
  rev1_meta: "Centralia — Instalación de Alfombra",
  rev2_text:
    "Pusieron LVP resistente al agua en la cocina y parece madera de verdad. Trabajo limpio, rápido y profesional de principio a fin.",
  rev2_name: "James T.",
  rev2_meta: "Chehalis — Vinyl Plank",
  rev3_text:
    "Diez años de arrugas en la alfombra desaparecieron en una tarde. Debí llamar a PERETE hace años.",
  rev3_name: "Sandra L.",
  rev3_meta: "Olympia — Re-estirado de Alfombra",

  dash_title: "Panel del Dueño",
  dash_site: "Sitio",
  dash_signout: "Salir",
  dash_quotes: "Cotizaciones",
  dash_upcoming: "Visitas Pendientes",
  dash_completed: "Completadas",
  dash_appointments: "Citas",
  dash_empty_appts: "No hay citas pendientes.",
  dash_archived: "Completadas y Archivadas",
  dash_quotes_h: "Solicitudes de Cotización",
  dash_empty_quotes: "Aún no hay cotizaciones.",
  dash_received: "Recibido",
  dash_done: "Completar",
  dash_reopen: "Reabrir",
  dash_toast_done: "Completada — archivada",
  dash_toast_reopen: "Movida a pendientes",
  dash_toast_fail: "No se pudo actualizar la cita.",
  dash_signed_out: "Sesión cerrada",
  dash_checking: "Verificando acceso…",
  dash_access: "Acceso del Dueño",
  dash_forbidden:
    "Esta cuenta de Google no está autorizada para el panel. Entra con la cuenta del negocio.",
  dash_login_sub:
    "Entra con tu cuenta de Google para ver las cotizaciones y las citas de medición.",
  dash_signin: "Entrar con Google",
  dash_back: "Volver al sitio",
  dash_expenses_link: "Gastos",
  exp_title: "Registro de Gastos",
  exp_sub: "Gastos del negocio — escribe el monto, elige la categoría y presiona Enter.",
  exp_month_total: "Gastado este mes",
  exp_month_count: "registros este mes",
  exp_top_category: "Categoría principal del mes",
  exp_filtered_total: "Total mostrado",
  exp_amount_ph: "0.00",
  exp_note_ph: "Nota (opcional)",
  exp_add: "Agregar",
  exp_adding: "Guardando…",
  exp_all: "Todos",
  exp_empty: "Aún no hay gastos. Agrega el primero arriba.",
  exp_empty_filter: "No hay gastos en esta categoría.",
  exp_added: "Gasto guardado",
  exp_removed: "Gasto eliminado",
  exp_fail: "No se pudo guardar el gasto.",
  exp_invalid_amount: "Ingresa un monto mayor a cero.",
  exp_delete: "Eliminar gasto",
  exp_dashboard: "Panel",
  exp_entries: "registros",
  cat_materials: "Materiales",
  cat_tools: "Herramientas",
  cat_gas: "Gasolina",
  cat_labor: "Mano de obra",
  cat_advertising: "Publicidad",
  cat_other: "Otros",
};

const translations = { en, es };

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("perete_lang") || "en"
  );
  const setLang = (l) => {
    localStorage.setItem("perete_lang", l);
    setLangState(l);
  };
  const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
